import { DBFactory } from "~/classes/database/db_factory";
import { BaseModel } from "../base.model";

type ClassroomLinkedUserConstructorParams = {
  userId: string;
  classroomId: string;
  // Eventually I can add roles here
};

export type ClassroomLinkedUsers = ClassroomLinkedUser[];

export class ClassroomLinkedUser extends BaseModel {
  id: string;
  userId: string;
  classroomId: string;
  // Eventually I can add roles here

  constructor(params: ClassroomLinkedUserConstructorParams) {
    super(params);
    this.id = params.userId;
    this.userId = params.userId;
    this.classroomId = params.classroomId;
  }

  override get databaseConfig() {
    return {
      collection: `/classrooms/${this.classroomId}/linkedUsers`,
      path: `/classrooms/${this.classroomId}/linkedUsers/${this.id}`,
    };
  }

  static override fromMap(map: any): ClassroomLinkedUser {
    return new ClassroomLinkedUser(map);
  }

  async save() {
    const db = await DBFactory.createDatabase();
    await db.save(this.toMap(), this.databaseConfig);
  }

  async delete() {
    const db = await DBFactory.createDatabase();
    await db.delete(this.databaseConfig);
  }
}
